// @flow
// ─── DEV-ONLY: mock roaming options until the API provides real roaming keys ──
// Centralised module — used by Subscriptions, NextPlan, and AvailableOption sagas.

import config from '../config';

// ── Private helpers ──────────────────────────────────────────────────────────

const isRoamingMockEnabled = () =>
  config.areCheatCodesEnabled && config.enableRoamingOptionsUsagesMock;

const USAGES_MOCK_OPTIONS = [
  {
    currentValue: 10485760,
    label: 'ROA6_DATA_CREDIT',
    maxValue: 15728640,
    unitType: 'VOLUME',
    endDateTime: 253402257600000,
    startDateTime: 0,
  },
  {
    currentValue: 3600,
    label: 'TO_ZONED_VOICE_CREDIT',
    maxValue: 7200,
    unitType: 'DURATION',
    endDateTime: 253402257600000,
    startDateTime: 0,
  },
];

/**
 * Injects mock roaming usages into the usages array.
 */
export const injectMockRoamingUsages = (usages) => {
  if (!isRoamingMockEnabled()) return usages;
  return [...(usages || []), ...USAGES_MOCK_OPTIONS];
};